import React from 'react';

const App = function(props) {
  return (
    <div className='body body--with-background'>
      { props.children }
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./app/components/layouts/App.jsx